import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class TimezoneService {
  timezones: TZone[] = null;

  getTimezones(): TZone[] {
    if (!!this.timezones) {
      return this.timezones;
    }

    const zones = new Set();
    const countries = moment.tz.countries();
    for (const c of countries) {
      moment.tz
        .zonesForCountry(c)
        .sort()
        .reduce((set, zone) => set.add(zone), zones);
    }

    this.timezones = Array.from(zones)
      .sort()
      .map((zone: string) => this.formatZone(zone));

    return this.timezones;
  }

  formatZone(zone: string): TZone {
    const utc: string = moment.tz(zone).format('Z');
    const abbr: string = moment.tz(zone).zoneAbbr();

    return {
      name: `${zone} (${utc}) (${abbr})`,
      nameValue: zone,
      timeValue: utc,
      group: abbr,
      abbr
    };
  }
}

export interface TZone {
  name: string;
  nameValue: string;
  timeValue: string;
  group: string;
  abbr: string;
}
